import useApiMutation from 'shared/hooks/use-api-mutation';
import {SaleProps} from '../types';
import productsKeys from '../util/products-keys';
import useQueryHelpers from 'shared/hooks/use-query-helpers';

const useUpdateSale = (saleId: string) => {
  const {update} = useQueryHelpers();
  const {setData} = useQueryHelpers();

  const onSuccess = (data: SaleProps) => {
    update(productsKeys.sales(data.productId!), data);
    setData(productsKeys.saleDetails(data.productId!, saleId), data);
  };

  return useApiMutation<SaleProps>({
    url: `/sales/${saleId}`,
    method: 'PATCH',
    errorTitle: 'Erro ao atualizar promoção',
    successTitle: 'Atualizar promoção',
    successMessage: 'Promoção atualizada com sucesso',
    redirectUrl: (data) => `/menu/products/${data.productId}/sales`,
    onSuccess,
  });
};

export default useUpdateSale;
